import React, { useState, useEffect } from "react";
import { toast } from "react-toastify";
import { makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Compressor from "compressorjs";

import { i18n } from "../../translate/i18n";
import api from "../../services/api";
import AerosDialog from "../AerosDialog";
import useAerosModalStyles from "../../styles/aerosModalStyles";

const useStyles = makeStyles((theme) => ({
  dropzone: {
    border: `1px dashed ${theme.palette.type === "light" ? theme.palette.aeros.borderStrong : "rgba(255,255,255,0.15)"}`,
    borderRadius: 11,
    padding: 16,
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: 10,
    fontSize: 12,
    color: theme.palette.text.secondary,
    textAlign: "center",
  },
  chooseBtn: { borderRadius: 8, fontSize: 12, fontWeight: 600, padding: "4px 12px" },
  preview: { maxWidth: "100%", maxHeight: 280, borderRadius: 8 },
  fileName: { fontSize: 12, color: theme.palette.text.primary, wordBreak: "break-all" },
}));

const FlowBuilderAddImgModal = ({ open, onSave, onUpdate, data, close }) => {
  const classes = useStyles();
  const m = useAerosModalStyles();
  const [activeModal, setActiveModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [preview, setPreview] = useState();
  const [medias, setMedias] = useState([]);

  useEffect(() => {
    if (open === "edit") {
      setPreview(process.env.REACT_APP_BACKEND_URL + "/public/" + data.data.url);
      setActiveModal(true);
    } else if (open === "create") {
      setActiveModal(true);
    } else {
      setActiveModal(false);
    }
  }, [open]);

  const handleClose = () => {
    close(null);
    setActiveModal(false);
    setMedias([]);
    setPreview();
  };

  const handleSaveContact = async () => {
    if (open === "edit") {
      handleClose();
      onUpdate({
        ...data,
        data: { url: "" },
      });
      return;
    } else if (open === "create") {
      setLoading(true);
      const formData = new FormData();
      formData.append("fromMe", true);

      medias.forEach(async (media) => {
        const file = media;

        if (!file) {
          return;
        }

        if (media?.type.split("/")[0] === "image") {
          new Compressor(file, {
            quality: 0.7,

            async success(media) {
              formData.append("medias", media);
              formData.append("body", media.name);
            },
            error(err) {
              alert("erro");
              console.log(err.message);
            },
          });
        } else {
          formData.append("medias", media);
          formData.append("body", media.name);
        }
      });

      setTimeout(async () => {
        await api.post("/flowbuilder/img", formData).then((res) => {
          handleClose();
          onSave({
            url: res.data.name,
          });
          toast.success(i18n.t("aeros.flow.modals.image.success"));
          setLoading(false);
        });
      }, 1000);
    }
  };

  const handleChangeMedias = (e) => {
    if (!e.target.files) {
      return;
    }

    if (e.target.files[0].size > 2000000) {
      toast.error(i18n.t("aeros.flow.modals.image.tooLarge"));
      return;
    }

    const selectedMedias = Array.from(e.target.files);
    setPreview(URL.createObjectURL(e.target.files[0]));
    setMedias(selectedMedias);
  };

  return (
    <AerosDialog
      open={activeModal}
      onClose={handleClose}
      width={560}
      title={i18n.t(open === "edit" ? "aeros.flow.modals.image.editTitle" : "aeros.flow.modals.image.addTitle")}
      onSubmit={open !== "edit" ? handleSaveContact : undefined}
      submitLabel={i18n.t("aeros.flow.add")}
      submitDisabled={medias.length === 0}
      loading={loading}
    >
      <div>
        <label className={m.fieldLabel}>{i18n.t("aeros.flow.nodes.image")}</label>
        <div className={classes.dropzone}>
          {preview && <img src={preview} alt="" className={classes.preview} />}
          {open !== "edit" && (
            <>
              <Button variant="outlined" component="label" size="small" className={classes.chooseBtn} disabled={loading}>
                {i18n.t("aeros.flow.content.chooseFile")}
                <input type="file" accept="image/png, image/jpg, image/jpeg" disabled={loading} hidden onChange={handleChangeMedias} />
              </Button>
              {medias[0] ? (
                <span className={classes.fileName}>{medias[0].name}</span>
              ) : (
                <span>{i18n.t("aeros.flow.modals.image.dropHint")}</span>
              )}
            </>
          )}
        </div>
      </div>
    </AerosDialog>
  );
};

export default FlowBuilderAddImgModal;
